import { VideoPath, Banner } from '../../components'
import { useEffect, useState } from 'react'
import footer from '../../assets/images/footer.png'
import Timeline from '../../components/Timeline'
import MediaQuery from 'react-responsive'
import "../../assets/less/learningPath.less";

import bi_introduce from '../../assets/images/BILearnPath/bi_introduce.png'
import bi_notintroduce from '../../assets/images/BILearnPath/bi_notintroduce.png'
import notconnect from '../../assets/images/BILearnPath/notconnect.png'
import connect from '../../assets/images/BILearnPath/connect.png'
import deal from '../../assets/images/BILearnPath/deal.png'
import notdeal from '../../assets/images/BILearnPath/notdeal.png'
import create from '../../assets/images/BILearnPath/create.png'
import notcreate from '../../assets/images/BILearnPath/notcreate.png'
import vision from '../../assets/images/BILearnPath/vision.png'
import notvision from '../../assets/images/BILearnPath/notvision.png'
import interactive from '../../assets/images/BILearnPath/interactive.png'
import notinteractive from '../../assets/images/BILearnPath/notinteractive.png'
import panel from '../../assets/images/BILearnPath/panel.png'
import notpanel from '../../assets/images/BILearnPath/notpanel.png'
const FinebiHome = () => {
  const [title, setTitle] = useState('FineBI 基礎學習路徑')
  const [index, setindex] = useState(0)
  const [person] = useState("bi_persons")
  const [path] = useState("finebi_basiclearning")
  const [alertMessage]=useState({message:"",alert:false})
  const [bannerData]=useState({h1:"FineBI 基礎學習路徑",p:"一小時零基礎入門，帶你進入FineBI的世界，了解FineBI數據分析全流程。",br:""})
  
  const [Homedata]=useState([{title:"第一章 FineBI基本介紹",
  description:"本章將帶你瞭解FineBI 產品定位、產品優勢、產品架構、產品功能",
  imageView:bi_introduce,
  imageNotView:bi_notintroduce,
  id:index + 1,
  lid:14,
  direction:"left"},
  {title:"第二章 連接到資料	",
  description:"本章將帶你瞭解資料上傳和資料更新的操作，透過案例演示掌握資料分析的第一步——資料準備",
  imageView:connect,
  imageNotView:notconnect,
  id:index + 2,
  lid:15,
  direction:"right"},
  {title:"第三章 使用自助資料集做資料處理	",
  description:"本章將帶你瞭解使用FineBI自助資料集來完成原始資料的預處理，以提升資料分析質量	",
  imageView:deal,
  imageNotView:notdeal,
  id:index + 3,
  lid:16,
  direction:"left"}, {title:"第四章 創建組件並分析資料",
  description:"本章將帶你瞭解FineBI多維分析，透過對資料進行調整、處理，使其更滿足資料呈現的需求",
  imageView:create,
  imageNotView:notcreate,
  id:index + 4,
  lid:17,
  direction:"right"}, {title:"第五章 視覺化組件",
  description:"本章將透過圖表的選擇和製作帶你掌握視覺化分析技巧",
  imageView:vision,
  imageNotView:notvision,
  id:index + 5,
  lid:18,
  direction:"left"}, {title:"第六章 添加交互效果",
  description:"本章將帶你瞭解FineBI交互效果，透過多組件協同以滿足實際複雜業務場景的分析需求",
  imageView:interactive,
  imageNotView:notinteractive,
  id:index + 6,
  lid:19,
  direction:"right"}, {title:"第七章 儀表板分享",
  description:"本章將帶你瞭解儀表板的整體佈局和美化，以及儀表板分享的內容",
  imageView:panel,
  imageNotView:notpanel,
  id:index + 7,
  lid:20,
  direction:"left"}])
                        
  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title
  }, [title])
  return (
    <>
      <Banner bannerData={bannerData} person={person} personNumber={12}/>
      <VideoPath Homedata={Homedata} path={path} {...alertMessage}/>
      {/* <MediaQuery maxWidth={1199}>
        <VideoPath />
      </MediaQuery>
      <MediaQuery minWidth={1200}>
        <Timeline />
      </MediaQuery> */}
      <footer>
        <img
          src={footer}
          alt="footer"
          style={{ width: '100%', background: '#f3f3f3' }}
        />
      </footer>
    </>
  )
}

export default FinebiHome
